import React, { FC, ReactElement } from 'react';
import {
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
  FieldErrors,
  UseFormReturn,
  UseFormStateReturn,
} from 'react-hook-form';
import { ScheduledEventForm } from '../models/ScheduledEventDto';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { AutoRelaySwitchScheduleEventDeviceConfig } from '@thingslog/repositories';
import { useTranslation } from 'react-i18next';

export const AutoRelaySwitchEvent: FC<AutoRelaySwitchEventProps> = ({
  form,
}: AutoRelaySwitchEventProps) => {
  const {
    control,
    formState: { errors: formErrors },
  } = form;

  const { t } = useTranslation();

  const errors = formErrors.event as FieldErrors<AutoRelaySwitchScheduleEventDeviceConfig>;

  return (
    <FormControl fullWidth size="small" error={!!errors?.requiredState}>
      <InputLabel id="required-state-label">
        {t('scheduled_task_event_form_required_state')}
      </InputLabel>
      <Controller
        name="event.requiredState"
        control={control}
        render={({
          field,
        }: {
          field: ControllerRenderProps<ScheduledEventForm, 'event.requiredState'>;
          fieldState: ControllerFieldState;
          formState: UseFormStateReturn<ScheduledEventForm>;
        }): ReactElement => (
          <Select
            {...field}
            labelId="required-state-label"
            label={t('scheduled_task_event_form_required_state')}
          >
            <MenuItem value="ON">{t('on')}</MenuItem>
            <MenuItem value="OFF">{t('off')}</MenuItem>
            <MenuItem value="AUTO">{t('auto')}</MenuItem>
          </Select>
        )}
      />
      {errors?.requiredState && <FormHelperText>{errors?.requiredState.message}</FormHelperText>}
    </FormControl>
  );
};

interface AutoRelaySwitchEventProps {
  form: UseFormReturn<ScheduledEventForm, unknown, undefined>;
}
